import "./popover.scss";

import { bindable, customElement, inject, bindingMode } from "aurelia-framework";
import Popper from "popper.js";

@customElement("popover")
@inject(Element)
export class Popover {
    private _element: HTMLElement;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isAxxessIntelligence: boolean = false;
    @bindable
    public title: string;

    @bindable
    public content: string;

    @bindable
    public parentId: string;

    @bindable
    public activeOnClick: boolean = false;

    @bindable
    public placement: Popper.Placement = "auto";

    @bindable
    public showCloseButton: boolean = false;

    public showPopover: boolean = false;
    public mouseOutTimeOut: NodeJS.Timer;
    private _outsideClickListener: (evt: MouseEvent) => void;

    public constructor(element: Element) {
        this._element = element as HTMLElement;
        this._outsideClickListener = (evt: MouseEvent) => this.handleClosePopOver(evt);
    }

    public async attached() {
        // if no parent id was provided, then one must be elected
        /* if (!this.parentId) {
            let refObj = this._element.parentElement;

            if (refObj.id == "" || !refObj.id) {
                refObj.id = UUID.v4();
            }

            this.parentId = refObj.id;
        } */

        // let parent = document.getElementById(this.parentId);
        let parent = this._element.parentElement;

        if (!parent) {
            // throw Error(`Could not find parent element with id '${this.parentId}'`);
            throw Error("Could not find parent element");
        }

        let options: Popper.PopperOptions = {
            placement: this.placement
        };

        let popper = new Popper(parent, this._element, options);

        if (this.activeOnClick) {
            parent.onclick = () => this.togglePopover(popper);
            document.addEventListener("click", this._outsideClickListener);
        } else {
            parent.onmouseover = () => this.mouseOver(popper);
            parent.onmouseout = () => this.mouseOut(popper);
        }
    }

    private handleClosePopOver(evt: Event) {
        if (!this.showPopover) {
            return;
        }
        if (!this._element.parentElement.contains(evt.target as Element)) {
            this.showPopover = false;
        }
    }

    public mouseOver(popper: Popper) {
        if (this.mouseOutTimeOut) {
            clearTimeout(this.mouseOutTimeOut);
        }
        this.showPopover = true;
        popper.scheduleUpdate();
    }

    public mouseOut(popper: Popper) {
        this.mouseOutTimeOut = setTimeout(() => {
            this.showPopover = false;
        }, 150);
    }

    public togglePopover(popper: Popper) {
        this.showPopover = !this.showPopover;
        popper.scheduleUpdate();
    }

    public detached() {
        document.removeEventListener("click", this._outsideClickListener);
    }
}
